export const url = `https://comic-zone.onrender.com/api/v1/`;
export const books_url = `${url}/`

export const COMIC = {
author: "",
categoryId: "",
createdAt: "",
description: "",
imageUrl: "",
price: "$25",
rating: 0,
releaseDate: "",
title: "",
updatedAt: "",
_id: "",
}

